







import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  HIDE_REQUEST_ERROR,
  SHOW_REQUEST_ERROR,
} from '@/store/constants/mutation-types';

@Component
export default class ErrorSnackBar extends Vue {
  private timeout: number = 15000;

  @(namespace('ErrorModule').State('errorText'))
  private errorText!: string;
  @(namespace('ErrorModule').State('hasErroredRequest'))
  private hasErroredRequest!: boolean;

  @(namespace('ErrorModule').Mutation(HIDE_REQUEST_ERROR))
  private hideRequestError!: () => void;

  get error(): boolean {
    return this.hasErroredRequest;
  }
  set error(error: boolean) {
    this.hideRequestError();
  }
}
